export const TAG_RESOURCES = `
  mutation TagResources($mapContractId: String!) {
    tagResources(mapContractId: $mapContractId) {
      error {
        code
        message
        statusCode
      }
      data {
        tagged
        failed
        errors
      }
    }
  }
`
